import { render } from "./ListeProduitRestreint.vue?vue&type=template&id=3daf7405&ts=true"
import script from "./ListeProduitRestreint.vue?vue&type=script&lang=ts"
export * from "./ListeProduitRestreint.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__